import { useState } from "react";
import Buttons from "./Button/Buttons";
import ModalPopupContact from "./ModalPopupContact";
import { useTranslation } from "react-i18next";

const BlogStickyBar = () => {
  const { t } = useTranslation(["blog"]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className='blog__sidebar-sticky w-full max-w-[280px] h-full'>
        <div className='blog__sidebar-sticky-inner is--active border-sm bg-inaqgold p-8 lg:px-0 sticky top-48'>
          <div className='flex justify-center items-center mb-3'>
            <img src='/assets/img/webp/inaq_logo_2x_web_white.webp' loading='lazy' alt='INAQ Logo' className='blog__sidebar-sticky-logo w-5 mr-3' />
            <div className='xxxl:text-[14px] lg:text-[12px] font-["Oxanium"] text-white cursor-default'>{t("sidebar.tagline", "B2B marketingová agentúra")}</div>
          </div>
          <div className='blog__sidebar-divider border-t border-white opacity-50'></div>
          <h3 className='blog__sidebar-h3 text-white xxxl:text-[14px] mt-2 ml-0 font-normal mb-0 font-rubik cursor-default lg:px-8 lg:leading-[26px] lg:py-4'>{t("sidebar.heading", "Čo viete získať spoluprácou s nami?")}</h3>
          <ul className='text-white/90 lg:px-8 mb-4 ml-5 list-square xxxl:text-[12px] font-rubik font-light [&>li]:before:text-white/80 [&>li]:marker:text-white/80'>
            <li className='mb-2 hover:text-white cursor-default'>{t("sidebar.bullets.strategy", "obsahová stratégia")}</li>
            <li className='mb-2 hover:text-white cursor-default'>{t("sidebar.bullets.analytics", "výkonnostná analytika")}</li>
            <li className='mb-2 hover:text-white cursor-default'>{t("sidebar.bullets.brand", "brandová komunikácia")}</li>
            <li className='mb-2 hover:text-white cursor-default'>{t("sidebar.bullets.ai", "AI automatizácia")}</li>
          </ul>
          <div className='flex justify-center mb-1'><Buttons type='button' onClick={() => setIsModalOpen(true)} className='rounded-sm font-medium font-rubik uppercase shadow-[0_0_30px_rgba(0,0,0,0.08)] hover:text-black py-2 px-4 text-center' themeColor={["#fff", "#fff"]} size='xs' backgroundColor='transparent' color='#212529' title={t("sidebar.cta", "Vyplňte formulár")} /></div>
        </div>
      </div>
      <ModalPopupContact isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default BlogStickyBar;
